import styled from "styled-components";

export const VerticalLineBox = styled.div`
    width: 1px;
    flex-grow: 1;
    background-color: ${props => props.theme.border.mainColor};
    min-height: 16px;
`